import { ModalViewModel } from '@/infra/ModalViewModel'
import { type Job } from '@/features/jobs/Job'
import { type JobProgressionStore } from '@/features/jobs/taxes/progression/JobProgressionStore'
import { task } from 'mobx-task'
import type { AlertErrorHandlerFactory } from '@/features/shell'

/**
 * Approves the draft return in review.
 */
export class ApproveDraftInReviewDialogViewModel {
  readonly modal = new ModalViewModel()

  constructor(
    private readonly _progressionStore: JobProgressionStore,
    private readonly _job: Job,
    private readonly _createAlertErrorHandler: AlertErrorHandlerFactory,
  ) {}

  /**
   * Moves the job to draft approved.
   */
  approveDraft = task.resolved(async () => {
    await this._progressionStore
      .transitionToStep(this._job.id, { step: 'DraftApproved' })
      .catch(this._createAlertErrorHandler('Approving the draft failed'))
    this.modal.close()
  })
}
